const CustomSwitch = function () 
{
    const toggleSwitch = function(el)
    {
        let statusSwitch = el.find('input[type="checkbox');
        
        if( statusSwitch.prop('checked') == false )
        {
            statusSwitch.prop('checked',true);
            $("#wrapper-grid-switch").find('.wf-descriptions').removeClass('show-in');
        } else {
            statusSwitch.prop('checked',false);
            $("#wrapper-grid-switch").find('.wf-descriptions').addClass('show-in');
        }
    }   

    return {
        init: function(){

            $(".activeSwitch").on("click", function(){
                toggleSwitch( $(this) );
            });

        }
    }


}();

module.exports = CustomSwitch;